import type { ChatPort } from '../domain/chat'

// Advances the viewer's read watermark. Failures are swallowed: a missed read
// receipt is not worth a toast and corrects itself on the next read.
const markRead = async (port: ChatPort, topicId: string, seqId: number): Promise<void> => {
	try {
		await port.markRead(topicId, seqId)
	} catch {
		// best-effort
	}
}

export { markRead }
